module.exports = __webpack_public_path__ + "img/8.ed770f9a.png";